module.exports = __webpack_public_path__ + "img/logo2x.5ae92ec0.png";